/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.SessionDataController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { DynamicContainer } from '../models/dynamic-container';
import { StringContainer } from '../models/string-container';

@Injectable()
export class SessionDataApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }

    public getSessionData(spinnerMessage: string = null): Observable<DynamicContainer> {
        return this.httpClient.get<DynamicContainer>(`/api/session`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }


    public setSessionData(request: StringContainer, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/session`, request,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

}
